/**
 * Page activation mixin — provide `activated` / `deactivated` lifecycle hooks
 * that fire every time the page becomes visible/invisible (even with keep-alive).
 *
 * Usage in any page component:
 *   import pageActivate from '@/mixins/pageActivate';
 *   export default { mixins: [pageActivate], methods: { onActivated() { ... } } }
 */
export default {
  data() {
    return {
      __pageActivateHandler: null,
      __pageDeactivateHandler: null
    };
  },
  created() {
    this.__pageActivateHandler = (e) => {
      if (e.detail && e.detail.page === this.$options.name) {
        if (typeof this.onActivated === 'function') this.onActivated(e.detail);
      }
    };
    this.__pageDeactivateHandler = (e) => {
      if (e.detail && e.detail.page === this.$options.name) {
        if (typeof this.onDeactivated === 'function') this.onDeactivated(e.detail);
      }
    };
    document.addEventListener('page:activate', this.__pageActivateHandler);
    document.addEventListener('page:deactivate', this.__pageDeactivateHandler);
  },
  beforeDestroy() {
    document.removeEventListener('page:activate', this.__pageActivateHandler);
    document.removeEventListener('page:deactivate', this.__pageDeactivateHandler);
  }
};
